import { useQuery } from '@tanstack/react-query';
import { fetchUrl } from '@utils/api';
import { DATA_FETCH_RETRY_COUNT } from '@config/contoursLayerConfig';

/**
 * Custom hook for fetching contour GeoJSON data
 * Encapsulates the React Query logic for loading contour files
 *
 * @param {string} projectUuid - Project UUID
 * @param {string} filePath - Path to the contour file
 * @param {boolean} enabled - Whether the query should run
 * @returns {Object} React Query result object
 */
export const useContoursData = (projectUuid, filePath, enabled = true) => {
	return useQuery({
		queryKey: ['contours', projectUuid, filePath],
		queryFn: async () => {
			const query = new URLSearchParams({ key: filePath });
			const data = await fetchUrl(`fileLink?${query.toString()}`);
			// const data = await fetchUrl(`fileLink?key=${filePath}`);
			if (data?.url) {
				const response = await fetch(data.url);
				if (!response.ok) throw new Error(`Failed to fetch contours: ${response.status}`);

				return await response.json();
			}
			throw new Error('No contours URL found');
		},
		enabled: !!projectUuid && !!filePath && enabled,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
		staleTime: Infinity,
		retry: DATA_FETCH_RETRY_COUNT,
	});
};
